import { ActionTree } from "vuex";
import { TerminalState, Terminal } from "./model";
import { RootStateType } from "@/store";
import { AxiosResponse } from "axios";

const actions: ActionTree<TerminalState, RootStateType> = {
  findList({ rootGetters, commit }) {
    return rootGetters['hcs/client'].get('/terminals')
      .then((response: AxiosResponse) => {
        const terminals: Terminal[] = response.data;
        commit('setTerminals', terminals)
        return terminals
      })
  },
  create({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].post('/terminals', params)
      .then((response: AxiosResponse) => {
        const terminal: Terminal = response.data;
        commit('addTerminal', terminal)
        return terminal
      })
  },
  update({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].patch(`/terminals/${params.id}`, params)
      .then((response: AxiosResponse) => {
        const terminal: Terminal = response.data;
        commit(('updateTerminal'), terminal)
        return terminal
      })
  },
  delete({ rootGetters, commit }, id) {
    return rootGetters['hcs/client'].delete(`/terminals/${id}`)
      .then((response: AxiosResponse) => {
        commit(('deleteTerminal'), id)
      })
  },
  fetchDockerFile({ rootGetters }, id) {
    return rootGetters['hcs/client'].get(`/terminals/${id}/download_docker_file`, { responseType:'blob' })
      .then((response: AxiosResponse) => {
        const credentialData = new Blob([response.data], {
          type: response.data.type
        });
        return credentialData
      })
  }
}

export default actions;
